import { LinesSkeleton } from "./LinesSkeleton";

export function RoomsSkeleton() {
  return (
    <div>
      {Array.from({ length: 2 }, (_, index) => (
        <div key={index} className="flex flex-col">
          <div className="flex h-[64px] animate-pulse items-center justify-between border-b border-[#EEEFF1] bg-[#FBFBFB] p-2">
            <div className="p-2">
              <div className="h-5 w-24 rounded bg-gray-300" />
            </div>
          </div>
          <LinesSkeleton />
        </div>
      ))}
    </div>
  );
}
